import React from 'react';
import { PillButton, Row } from 'library/ui';

export default function MainButtons({
    onSetPreferredClick,
    onNoClick,
}: {
    onSetPreferredClick: () => void;
    onNoClick: () => void;
}) {
    return (
        <Row gap="md" justify="center" wrap>
            <PillButton variant="secondary" onClick={onNoClick}>
                No, not right now
            </PillButton>
            <PillButton onClick={onSetPreferredClick}>Yes, please add</PillButton>
        </Row>
    );
}
